"use client"
import { useEffect, useRef } from "react"

const Hero = () => {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    const ctx = canvas.getContext("2d")
    canvas.width = window.innerWidth
    canvas.height = window.innerHeight

    // Medical-themed color palette
    const colors = {
      primary: "#34d399", // Emerald green
      secondary: "#3b82f6", // Blue
      accent: "#8b5cf6", // Purple
      light: "#d1fae5", // Light green
      white: "#ffffff"
    }

    // Background gradient particles (dots)
    class BackgroundParticle {
      constructor() {
        this.x = Math.random() * canvas.width
        this.y = canvas.height - Math.random() * 150 // Start at bottom
        this.size = Math.random() * 3 + 1
        this.speedY = -0.2
        this.color = `rgba(212, 237, 218, ${Math.random() * 0.3})`
      }

      draw() {
        ctx.fillStyle = this.color
        ctx.beginPath()
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2)
        ctx.fill()
      }

      update() {
        this.y += this.speedY
        if (this.y < canvas.height - 200) {
          this.y = canvas.height + 10
          this.x = Math.random() * canvas.width
        }
        this.draw()
      }
    }

    const backgroundParticles = []
    const bgParticleCount = 50

    // Initialize background particles
    for (let i = 0; i < bgParticleCount; i++) {
      backgroundParticles.push(new BackgroundParticle())
    }

    // Create gradient background
    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height)
    gradient.addColorStop(0, "#0f2a1c")
    gradient.addColorStop(1, "#1a3324")

    // Animation loop
    const animate = () => {
      // Fill with gradient
      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // Update background particles
      backgroundParticles.forEach(particle => particle.update())
      requestAnimationFrame(animate)
    }
    animate()

    // Handle window resize
    const handleResize = () => {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <section className="pt-36 pb-20 bg-gradient-to-b from-[#0f2a1c] to-[#1a3324] text-white flex items-center justify-center h-[100vh] relative overflow-hidden">
      <canvas
        ref={canvasRef}
        className="absolute inset-0 pointer-events-none"
        style={{ zIndex: 1 }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative" style={{ zIndex: 2 }}>
        <h1 className="text-6xl md:text-8xl font-extrabold tracking-tight mb-6 bg-gradient-to-r from-emerald-300 via-blue-300 to-purple-300 bg-clip-text text-transparent animate-gradient">
          Mediwhistle
        </h1>
        {/* <p className="text-xl md:text-2xl opacity-90 mb-8 text-emerald-100 font-light">
          Your trusted partner for medical alerts & orders
        </p> */}
        {/* <div className="flex gap-4 justify-center mt-12">
          <button className="px-8 py-4 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl">
            Get Started
          </button>
          <button className="px-8 py-4 border-2 border-emerald-400 text-emerald-300 hover:bg-emerald-400/10 font-semibold rounded-xl transition-all duration-300 transform hover:scale-105">
            Learn More
          </button>
        </div> */}
      </div>
    </section>
  )
}

export default Hero